import { useCallback } from "react";
import api from "../config/api/axiosConfig";

export const useAdminApi = () => {
  const getAllUsersByFontenehusId = useCallback(
    async (fontenehusId: number | undefined) => {
      const response = await api.get("/Admin/Users", {
        params: { fontenehusId },
      });
      return response;
    },
    [],
  );

  const updateUserRoles = useCallback(
    async (userId: number, roles: string[]) => {
      const response = await api.put(`/Admin/UpdateRoles/${userId}`, {
        roles: roles, // ✅ array of strings
      });
      return response;
    },
    [],
  );

  return {
    getAllUsersByFontenehusId,
    updateUserRoles,
  };
};
